function instanceVideo() {
  function init() {
    const videos = jQuery("video");
    console.log("videos", videos);
    for (let index = 0; index < videos.length; index++) {
      const video = videos[index];


      const jqueryVideo = jQuery(video);
      //jqueryVideo.attr({autoplay:true})
      video.addEventListener(
        "ended",
        function () {
          this.currentTime = 0;
          this.play();
        },
        false
      );
      video.autoplay = true;
      video.load();
      //video.play();
    }
    const listVideos = jQuery(".ux-video");
    for (let index = 0; index < listVideos.length; index++) {
      const element = listVideos[index];
      jQuery(element).on("click", activeVideo);
    }
  }
  function activeVideo() {
    const currentElement = jQuery(this);
    currentElement.off();
    const video = currentElement.find("video")[0];
    if (!video) {
      return;
    }
    video.controls = true;
    console.log('paused', video.paused)
    currentElement.addClass("active");
    if (video.paused) {
      setTimeout(() => {
        console.log('ejecutando');
        video.currentTime = 0;
        video.play();
      }, 100);
    } else {
      video.pause();
    }
    setTimeout(() => {
      const top = currentElement.position().top;
      const header = jQuery(jQuery(".component-menu-header")[0]);
      const y = top - header.position().top - header.height();// + + space;


      jQuery(window).scrollTop(y, 1000);
    }, 100);

  }
  init();
}

instanceVideo();
